import * as React from 'react';
import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgRatingWink = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="M15.5 11.25a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"
    />
    <path
      fill="#2D2E2E"
      d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z"
    />
    <path
      fill="#2D2E2E"
      d="M12 16c-1.43 0-2.72-.75-3.45-2.01l-1.73 1C7.9 16.85 9.88 18 12 18c2.12 0 4.1-1.15 5.18-3.01l-1.73-1C14.72 15.25 13.43 16 12 16ZM10.25 8.5h-3.5v2h3.5v-2Z"
    />
  </svg>
);
export default SvgRatingWink;
